import React from 'react';
import {connect} from 'react-redux';
import {Flex, ToogleSwitch} from '/app/src/component';

class AutoResponseMainPanel extends React.Component {

    _renderAutoresponse(){
        return (
            <Flex>
                <Flex>
                    <ToogleSwitch on={true}/>
                </Flex>
                <Flex column>
                    <Flex>
                        Autorespons med e-postformulär.
                    </Flex>
                    <Flex>
                        Om ni inte hinner svara inom 2 minuter får besökaren upp ett emailformulär
    i chatten så att de kan få svar vid senare tillfälle om de inte har tid att vänta.
                    </Flex>
                </Flex>
            </Flex>
        )
    }
    _renderAutoresponseField(){
        return (
            <Flex>
                <Flex>
                    <ToogleSwitch on={false}/>
                </Flex>
                <Flex column>
                    <Flex>
                        Autorespons med e-postformulär.
                    </Flex>
                    <Flex>
                        Om ni inte hinner svara inom 2 minuter får besökaren upp ett emailformulär
    i chatten så att de kan få svar vid senare tillfälle om de inte har tid att vänta.
                    </Flex>
                </Flex>
            </Flex>        )

    }
    render() {
        return(
            <Flex column>
                {this._renderAutoresponse()}
                {this._renderAutoresponseField()}
            </Flex>
        );
    }
}

function mapStateToProps(state, props){
    return {
    }
}
export default connect(mapStateToProps)(AutoResponseMainPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/AutoResponse/index.js